
const setModalTitle = (context, payload) => {
  context.commit('setModalTitle', payload);
}

const setSVGType = (context, payload) => {
  context.commit('setSVGType', payload);
}

const setModalMessage = (context, payload) => {
  context.commit('setModalMessage', payload);
}

const setModalVisible = (context, payload) => {
  context.commit('setModalVisible', payload);
}

export default {
  setModalTitle,
  setSVGType,
  setModalMessage,
  setModalVisible,
}